import React from "react";

export const LoadingComponent = ({message}) => {
    return(
        <div className={'flex flex-col justify-center items-center'}>
            <span className="loading loading-dots loading-lg"></span>
            <p className={'text-center font-semibold'}>{message ?? 'Loading'}</p>
        </div>
    )
}